import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import './MessageBubble.css';

export default function MessageBubble({ role, content, image, isStreaming, filteredWordCount }) {
  const isUser = role === 'user';

  return (
    <div className={`msg-row ${isUser ? 'msg-row--user' : 'msg-row--assistant'}`}>
      {!isUser && <div className="msg-avatar">P</div>}
      <div className="msg-col">
        <div className={`msg-bubble ${isUser ? 'msg-bubble--user' : 'msg-bubble--assistant'}`}>
          {image ? (
            <img className="msg-image" src={image} alt={content || 'Generated'} />
          ) : !content && isStreaming ? (
            <span className="typing-dots">
              <span />
              <span />
              <span />
            </span>
          ) : isUser ? (
            <div className="msg-plain">{content}</div>
          ) : (
            <div className="msg-markdown">
              <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeHighlight]}>
                {content}
              </ReactMarkdown>
              {isStreaming && <span className="stream-caret" />}
            </div>
          )}
        </div>
        {!isUser && !isStreaming && filteredWordCount > 0 && (
          <div className="msg-filtered-note">
            {filteredWordCount} word{filteredWordCount === 1 ? '' : 's'} filtered for privacy
          </div>
        )}
      </div>
    </div>
  );
}
